export default {
  linearRegressionHeadline: 'Regresja liniowa',
  ployfit: {
    headline: 'Dopasowanie wielomianowe',
    degree: 'Stopień',
  },
};
